// extracted by extract-css-chunks-webpack-plugin
module.exports = {"honor":"honor_ZT0YZ"};